import { Navigate } from 'react-router-dom';
import { authSession } from '../services/authSession';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

/**
 * This Guard uses volatile (in-memory) state.
 * If the page is reloaded (F5) or visited for the first time,
 * this state is always "false" and redirects to login.
 */
export const AdminProtectedRoute = ({ children }: ProtectedRouteProps) => {
  const isAuth = authSession.isAuthenticated();
  
  if (!isAuth) {
    return <Navigate to="/astadmin/login" replace />;
  }

  return <>{children}</>;
};
